module.exports = __webpack_public_path__ + "img/KinokoTable39.e524ae76.jpg";